<template>
  <div class="rs-page">
    <div class="rs-bg-circle rs-bg-circle--1"></div>
    <div class="rs-bg-circle rs-bg-circle--2"></div>

    <!-- ── Left panel (branding) ── -->
    <div class="rs-left">
      <div class="rs-left__inner">
        <img src="/logo-booster.png" alt="VSLBooster" class="rs-left__logo" />

        <div class="rs-left__headline">
          Sua jornada começa<br/>
          <span class="rs-left__accent">aqui.</span>
        </div>

        <p class="rs-left__sub">
          Configure sua senha e tenha acesso completo ao painel VSL Booster — onde você transforma dados de vídeo em conversões reais.
        </p>

        <div class="rs-left__bullets">
          <div class="rs-left__bullet">
            <span class="rs-left__bullet-icon">📊</span>
            <span>Heatmaps e retenção frame a frame</span>
          </div>
          <div class="rs-left__bullet">
            <span class="rs-left__bullet-icon">🎯</span>
            <span>CTA inteligente com momento ideal de exibição</span>
          </div>
          <div class="rs-left__bullet">
            <span class="rs-left__bullet-icon">🚀</span>
            <span>Embed em qualquer página em menos de 1 minuto</span>
          </div>
        </div>
      </div>
    </div>

    <!-- ── Right panel (form) ── -->
    <div class="rs-right">
      <div class="rs-card">
        <!-- Logo mobile only -->
        <div class="rs-card__logo-mobile">
          <img src="/logo-booster.png" alt="VSLBooster" />
        </div>

        <!-- Header -->
        <div class="rs-header">
          <div class="rs-icon-wrap">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
              <rect x="5" y="11" width="14" height="10" rx="2" stroke="#E86A10" stroke-width="2"/>
              <path d="M8 11V7a4 4 0 018 0v4" stroke="#E86A10" stroke-width="2" stroke-linecap="round"/>
              <circle cx="12" cy="16" r="1.5" fill="#E86A10"/>
            </svg>
          </div>
          <h1 class="rs-title">Configure sua senha</h1>
          <p class="rs-subtitle" v-if="user_email">
            Conta: <strong>{{ user_email }}</strong>
          </p>
          <p class="rs-subtitle" v-else>
            Escolha uma senha forte para proteger sua conta
          </p>
        </div>

        <!-- Form -->
        <validation-observer ref="simpleRules">
          <form class="rs-form" @submit.prevent="validationForm">

            <validation-provider
              #default="{ errors }"
              name="Nova senha"
              vid="Password"
              rules="required|password"
            >
              <div class="rs-field" :class="{ 'rs-field--error': errors.length > 0 }">
                <label class="rs-label">Nova senha</label>
                <div class="rs-input-wrap">
                  <svg class="rs-field-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <rect x="5" y="11" width="14" height="10" rx="2" stroke="#94a3b8" stroke-width="1.5"/>
                    <path d="M8 11V7a4 4 0 018 0v4" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"/>
                  </svg>
                  <input
                    id="reset-password-new"
                    v-model="password"
                    :type="password1FieldType"
                    class="rs-input"
                    placeholder="••••••••"
                    autocomplete="new-password"
                  />
                  <button type="button" class="rs-eye-btn" @click="togglePassword1Visibility">
                    <svg v-if="password1FieldType === 'password'" width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="#94a3b8" stroke-width="1.5"/>
                      <circle cx="12" cy="12" r="3" stroke="#94a3b8" stroke-width="1.5"/>
                    </svg>
                    <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"/>
                      <line x1="1" y1="1" x2="23" y2="23" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                  </button>
                </div>
                <span v-if="errors[0]" class="rs-error-msg">{{ errors[0] }}</span>
              </div>
            </validation-provider>

            <validation-provider
              #default="{ errors }"
              name="Confirmar senha"
              rules="required|confirmed:Password"
            >
              <div class="rs-field" :class="{ 'rs-field--error': errors.length > 0 }">
                <label class="rs-label">Confirmar nova senha</label>
                <div class="rs-input-wrap">
                  <svg class="rs-field-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M9 12l2 2 4-4" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <rect x="5" y="11" width="14" height="10" rx="2" stroke="#94a3b8" stroke-width="1.5"/>
                    <path d="M8 11V7a4 4 0 018 0v4" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"/>
                  </svg>
                  <input
                    id="reset-password-confirm"
                    v-model="cPassword"
                    :type="password2FieldType"
                    class="rs-input"
                    placeholder="••••••••"
                    autocomplete="new-password"
                  />
                  <button type="button" class="rs-eye-btn" @click="togglePassword2Visibility">
                    <svg v-if="password2FieldType === 'password'" width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="#94a3b8" stroke-width="1.5"/>
                      <circle cx="12" cy="12" r="3" stroke="#94a3b8" stroke-width="1.5"/>
                    </svg>
                    <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"/>
                      <line x1="1" y1="1" x2="23" y2="23" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                  </button>
                </div>
                <span v-if="errors[0]" class="rs-error-msg">{{ errors[0] }}</span>
              </div>
            </validation-provider>

            <!-- Requisitos -->
            <div class="rs-reqs">
              <div class="rs-req" :class="{ 'rs-req--ok': password.length >= 8 }">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
                  <path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                8+ caracteres
              </div>
              <div class="rs-req" :class="{ 'rs-req--ok': /[A-Z]/.test(password) }">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
                  <path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Maiúscula
              </div>
              <div class="rs-req" :class="{ 'rs-req--ok': /\d/.test(password) }">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
                  <path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Número
              </div>
            </div>

            <!-- Barra de força -->
            <div class="rs-strength">
              <div class="rs-strength__bar">
                <div
                  class="rs-strength__fill"
                  :style="{ width: strengthPct + '%', background: strengthColor }"
                ></div>
              </div>
              <span class="rs-strength__label" :style="{ color: strengthColor }">{{ strengthLabel }}</span>
            </div>

            <button
              type="submit"
              class="rs-btn"
              :class="{ 'rs-btn--loading': loading }"
              :disabled="loading"
            >
              <span v-if="!loading">
                Acessar o painel
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style="margin-left:6px;vertical-align:-3px">
                  <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
              <span v-else class="rs-spinner"></span>
            </button>

          </form>
        </validation-observer>

        <div class="rs-footer">
          <router-link :to="{ name: 'auth-login' }" class="rs-back-link">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M19 12H5M5 12l7 7M5 12l7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Voltar ao login
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: { ValidationProvider, ValidationObserver },
  data() {
    const routeEmail = this.$route.params.user_email
    const storedEmail = sessionStorage.getItem('rst_user_email') || ''
    const resolvedEmail = (!routeEmail || routeEmail === 'undefined')
      ? storedEmail
      : decodeURIComponent(routeEmail)
    return {
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || "/api/dkbackend",
      user_email: resolvedEmail,
      cPassword: '',
      password: '',
      loading: false,
      user_primeiro_acesso: 0,
      required,
      password1FieldType: 'password',
      password2FieldType: 'password',
    }
  },
  computed: {
    strengthScore() {
      let s = 0
      if (this.password.length >= 8) s++
      if (this.password.length >= 12) s++
      if (/[A-Z]/.test(this.password)) s++
      if (/\d/.test(this.password)) s++
      if (/[^A-Za-z0-9]/.test(this.password)) s++
      return s
    },
    strengthPct() {
      return (this.strengthScore / 5) * 100
    },
    strengthColor() {
      if (this.strengthScore <= 1) return '#EF4444'
      if (this.strengthScore <= 2) return '#F59E0B'
      if (this.strengthScore <= 3) return '#F5B935'
      return '#10B981'
    },
    strengthLabel() {
      if (!this.password) return ''
      if (this.strengthScore <= 1) return 'Fraca'
      if (this.strengthScore <= 2) return 'Razoável'
      if (this.strengthScore <= 3) return 'Boa'
      return 'Forte'
    },
  },
  methods: {
    togglePassword1Visibility() {
      this.password1FieldType = this.password1FieldType === 'password' ? 'text' : 'password'
    },
    togglePassword2Visibility() {
      this.password2FieldType = this.password2FieldType === 'password' ? 'text' : 'password'
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success === true) {
          this.loading = true
          this.redefinirSenha()
        }
      })
    },
    convertToBrasiliaTime() {
      const date = new Date()
      date.setHours(date.getHours() - 3)
      return date.toISOString().slice(0, 19).replace('T', ' ')
    },
    redefinirSenha() {
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/passwordEmail/`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          user_password: this.password,
          user_primeiro_acesso: this.user_primeiro_acesso,
          user_email: this.user_email,
          user_data_primeiro_acesso: this.convertToBrasiliaTime(),
        }),
      })
        .then(() => {
          sessionStorage.removeItem('rst_user_email')
          sessionStorage.removeItem('rst_user_id')
          this.$toast({
            component: ToastificationContent,
            props: { title: 'Senha definida! Bem-vindo ao VSL Booster 🚀', icon: 'CheckIcon', variant: 'success' },
          })
          this.$router.push({ name: 'auth-login' })
        })
        .catch(err => {
          console.error(err)
          this.loading = false
        })
    },
  },
}
</script>

<style scoped>
/* ─── Reset ─── */
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

/* ─── Page ─── */
.rs-page {
  min-height: 100vh;
  display: flex;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  position: relative;
  overflow: hidden;
}

/* ─── Background circles (left panel) ─── */
.rs-bg-circle {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  z-index: 0;
}
.rs-bg-circle--1 {
  width: 600px; height: 600px;
  background: radial-gradient(circle, rgba(232,106,16,0.18) 0%, transparent 65%);
  top: -150px; left: -100px;
}
.rs-bg-circle--2 {
  width: 400px; height: 400px;
  background: radial-gradient(circle, rgba(245,185,53,0.10) 0%, transparent 65%);
  bottom: -80px; left: 150px;
}

/* ─── Left panel ─── */
.rs-left {
  flex: 0 0 46%;
  background: linear-gradient(150deg, #0D1B2E 0%, #0D3349 55%, #0a2235 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 52px;
  position: relative;
  z-index: 1;
}

.rs-left__inner {
  max-width: 380px;
  position: relative;
  z-index: 2;
}

.rs-left__logo {
  height: 42px;
  width: auto;
  object-fit: contain;
  margin-bottom: 52px;
  display: block;
}

.rs-left__headline {
  font-size: 2.6rem;
  font-weight: 900;
  color: #fff;
  line-height: 1.15;
  letter-spacing: -1px;
  margin-bottom: 20px;
}

.rs-left__accent {
  background: linear-gradient(90deg, #E86A10, #F5B935);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.rs-left__sub {
  color: rgba(255,255,255,0.62);
  font-size: 0.95rem;
  line-height: 1.7;
  margin-bottom: 40px;
}

.rs-left__bullets {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.rs-left__bullet {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  color: rgba(255,255,255,0.80);
  font-size: 0.875rem;
  line-height: 1.5;
}

.rs-left__bullet-icon {
  font-size: 1rem;
  flex-shrink: 0;
  margin-top: 1px;
}

/* ─── Right panel ─── */
.rs-right {
  flex: 1;
  background: #F8FAFC;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
  position: relative;
  z-index: 1;
}

/* ─── Card ─── */
.rs-card {
  width: 100%;
  max-width: 420px;
  background: #fff;
  border-radius: 20px;
  padding: 40px 36px 32px;
  box-shadow: 0 8px 40px rgba(15,23,42,0.10), 0 0 0 1px rgba(15,23,42,0.06);
}

/* Logo visible only on mobile */
.rs-card__logo-mobile {
  display: none;
  text-align: center;
  margin-bottom: 28px;
}
.rs-card__logo-mobile img {
  height: 36px;
  width: auto;
}

/* ─── Header ─── */
.rs-header { text-align: center; margin-bottom: 28px; }

.rs-icon-wrap {
  width: 58px; height: 58px;
  background: linear-gradient(135deg, #FFF3EA, #FFE0C4);
  border-radius: 16px;
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 16px;
  box-shadow: 0 4px 16px rgba(232,106,16,0.18);
}

.rs-title {
  font-size: 1.45rem;
  font-weight: 800;
  color: #0D1B2E;
  margin: 0 0 8px;
  letter-spacing: -0.3px;
}

.rs-subtitle {
  font-size: 13px;
  color: #64748b;
  margin: 0;
  line-height: 1.5;
  word-break: break-all;
}
.rs-subtitle strong { color: #334155; }

/* ─── Form ─── */
.rs-form { display: flex; flex-direction: column; gap: 16px; }

.rs-field { display: flex; flex-direction: column; gap: 6px; }

.rs-label {
  font-size: 13px;
  font-weight: 600;
  color: #0D1B2E;
  letter-spacing: 0.1px;
}

.rs-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.rs-field-icon {
  position: absolute;
  left: 14px;
  pointer-events: none;
  flex-shrink: 0;
}

.rs-input {
  width: 100%;
  padding: 12px 44px 12px 42px;
  border: 1.5px solid #E2E8F0;
  border-radius: 12px;
  font-size: 14px;
  color: #0D1B2E;
  background: #F8FAFC;
  transition: all 0.2s;
  outline: none;
  font-family: inherit;
}
.rs-input::placeholder { color: #94a3b8; letter-spacing: 2px; }
.rs-input:focus {
  border-color: #E86A10;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(232,106,16,0.10);
}

.rs-field--error .rs-input { border-color: #EF4444; background: #FFF5F5; }
.rs-field--error .rs-input:focus { box-shadow: 0 0 0 3px rgba(239,68,68,0.10); }

.rs-eye-btn {
  position: absolute; right: 12px;
  background: none; border: none;
  padding: 4px; cursor: pointer;
  display: flex; align-items: center;
  border-radius: 6px; transition: background 0.15s;
}
.rs-eye-btn:hover { background: #F1F5F9; }

.rs-error-msg { font-size: 12px; color: #EF4444; font-weight: 500; }

/* ─── Requisitos ─── */
.rs-reqs { display: flex; flex-wrap: wrap; gap: 6px; margin-top: -4px; }

.rs-req {
  display: flex; align-items: center; gap: 4px;
  font-size: 11.5px; font-weight: 500; color: #94a3b8;
  padding: 4px 8px; border-radius: 6px;
  background: #F1F5F9; transition: all 0.25s;
}
.rs-req--ok { color: #059669; background: #F0FDF4; }
.rs-req--ok svg path { stroke: #059669; }

/* ─── Barra de força ─── */
.rs-strength {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: -6px;
}
.rs-strength__bar {
  flex: 1;
  height: 4px;
  background: #E2E8F0;
  border-radius: 999px;
  overflow: hidden;
}
.rs-strength__fill {
  height: 100%;
  border-radius: 999px;
  transition: width 0.3s, background 0.3s;
}
.rs-strength__label {
  font-size: 11px;
  font-weight: 700;
  min-width: 48px;
  text-align: right;
  transition: color 0.3s;
  letter-spacing: 0.3px;
}

/* ─── Botão ─── */
.rs-btn {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #E86A10 0%, #F5B935 100%);
  border: none; border-radius: 12px;
  color: #fff; font-size: 15px; font-weight: 700;
  cursor: pointer; transition: all 0.2s;
  letter-spacing: 0.2px;
  box-shadow: 0 4px 18px rgba(232,106,16,0.32);
  margin-top: 4px;
  display: flex; align-items: center; justify-content: center;
  min-height: 50px;
  font-family: inherit;
}
.rs-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 24px rgba(232,106,16,0.42);
}
.rs-btn:active:not(:disabled) { transform: translateY(0); }
.rs-btn:disabled { opacity: 0.65; cursor: not-allowed; }

/* ─── Spinner ─── */
.rs-spinner {
  width: 20px; height: 20px;
  border: 2px solid rgba(255,255,255,0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: rs-spin 0.7s linear infinite;
  display: block;
}
@keyframes rs-spin { to { transform: rotate(360deg); } }

/* ─── Footer ─── */
.rs-footer {
  text-align: center; margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #F1F5F9;
}
.rs-back-link {
  display: inline-flex; align-items: center; gap: 6px;
  font-size: 13px; font-weight: 600; color: #64748b;
  text-decoration: none; transition: color 0.2s;
}
.rs-back-link:hover { color: #E86A10; }
.rs-back-link svg { transition: transform 0.2s; }
.rs-back-link:hover svg { transform: translateX(-3px); }

/* ─── Responsive ─── */
@media (max-width: 860px) {
  .rs-page { flex-direction: column; }
  .rs-left { display: none; }
  .rs-right { flex: 1; min-height: 100vh; background: linear-gradient(150deg, #0D1B2E 0%, #0D3349 55%, #0a2235 100%); }
  .rs-card { background: rgba(255,255,255,0.98); box-shadow: 0 25px 60px rgba(0,0,0,0.35); }
  .rs-card__logo-mobile { display: block; }
  .rs-title { color: #0D1B2E; }
}

@media (max-width: 480px) {
  .rs-right { padding: 24px 16px; }
  .rs-card { padding: 32px 24px 28px; border-radius: 16px; }
  .rs-title { font-size: 1.25rem; }
}
</style>
